// Module
var code = `<div class="gainers-losers-panel">

    <div class="gainers-losers-panel-toolbar" name="ToolBar" style="display: {{showToolbar ? 'flex' : 'none'}};">

        <terceraComboBox name="AlgorithmsList"
            visible="false"
            items={{algorithmsListItems}} 
            on-ValueChange="selectedAlgorithmChanged"/>

        <terceraMultiComboBox name="ExchangeFilter"
            items={{exchangeFilterItems}} 
            showLastValue="true" 
            on-ValueChange="exchangeFilterChanged"/>

        {{#if timeRangeFilterVisible}}
            <terceraComboBox name="TimeRange"
                items={{timeRangeItems}} 
                on-ValueChange="selectedTimeRangeChanged"/>
        {{/if}}

    </div>

    <div class="gainers-losers-panel-table-sector">
        <div class="gainers-losers-tables-captions">
            <div class="gainers-table-caption">
                {{'Gainers'}}
            </div>
            <div class="losers-table-caption">
                {{'Losers'}}
            </div>
        </div>
        <div class="gainers-losers-tables">
            <terceraPanel name='windowPanelBodyQT' />
        </div>

        <div class="GainerLosersTable-noDataContainer">
            <div class="GainerLosersTable-noData {{noDataForGainers ? 'has-no-data' : ''}}">
                {{#if noDataForGainers && showNoDataIcon}}
                    <div class="GainerLosersTable-noDataInfoIcon">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#gainersLosers"></use>
                        </svg>
                    </div>
                    <div class="GainerLosersTable-noDataText">{{noDataText}}</div>
                {{/if}}
            </div>
            <div class="GainerLosersTable-noData {{noDataForLosers ? 'has-no-data' : ''}}">
                {{#if noDataForLosers && showNoDataIcon}}
                    <div class="GainerLosersTable-noDataInfoIcon">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#gainersLosers"></use>
                        </svg>
                    </div>
                    <div class="GainerLosersTable-noDataText">{{noDataText}}</div>
                {{/if}}
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;